import React from 'react'
import { classNames } from '../../utils'

const LoadingWrapper = ({isShow, children}) => {
  return (
    <div className={classNames('loading-wrapper', {
        "loading-wrapper__show": isShow
    })}>{children} <span className="loading-wrapper__icon" /></div>
  )
}

export default LoadingWrapper